/**
 *
 */
import React, { Fragment, useState } from 'react';

//Apis
import { authForgotPassword } from '../tm-apis';

//Helpers
import {
    setDefaultEnvObj,
    gtmSend,
} from '@tickled-media/web-components.tm-helpers';

//Icons
import TapIcon from './icons/TapIcon';
import CrossRegularSmdBlackIcon from './icons/CrossRegularSmdBlackIcon';

//Other Components
import ThreeBounceAnimationIcon from '@tickled-media/web-components.tm-three-bounce-loader';
import Notification from '@tickled-media/web-components.tm-notification';

//Style files
import cx from 'classnames/bind';
import './style.css';

const ResetLinkSuccessWidget = (props) => {
    const {
        email,
        type,
        mobileNumber,
        countryCode,
        onForgotPasswordClose,
        onSendResetLink,
        translation,
    } = props;

    const onClose = () => {
        if (onForgotPasswordClose) onForgotPasswordClose(false);
        if (onSendResetLink) onSendResetLink(false);
    };

    return (
        <Fragment>
            <div className={cx(`forgot-password-close-icon`)} onClick={onClose}>
                <CrossRegularSmdBlackIcon />
            </div>
            <div className={cx(`reset-link-wrap`)}>
                <TapIcon />
                {type === 'email' ? (
                    <p>
                        {translation[`passwordResetLink1`]} <span>{email}</span>
                        . {translation[`passwordResetLink2`]}.
                    </p>
                ) : (
                    <div className={cx('reset-mobile-text')}>
                        <p>{translation[`passwordResetLinkMobile`]}</p>
                        <p
                            className={cx('mobile-number')}
                        >{`${countryCode} ${mobileNumber}`}</p>
                    </div>
                )}
                <button className={cx(`ok-btn`)} onClick={onClose}>
                    {translation[`ok`]}
                </button>
            </div>
        </Fragment>
    );
};

const ForgotPasswordOTPWidget = (props) => {
    const {
        user,
        email,
        type,
        mobileNumber,
        countryCode,
        isoCode,
        onForgotPasswordClose,
        translation,
    } = props;

    const [sendResetLink, setSendResetLink] = useState(false),
        [isLoading, setLoading] = useState(false);

    const onSendResetLink = (flag) => {
        setSendResetLink(flag);
    };

    const onForgotPasswordBtnClick = () => {
        gtmSend(
            `loginSignup`,
            `Login and Signup`,
            `Forgot Password - Send Link via ${type === 'email' ? 'Email' : 'Mobile'}`,
            `--`,
            0,
            {
                action_detail: `Forgot Password - Send Link via ${type === 'email' ? 'Email' : 'Mobile'}`,
            }
        );
        setLoading(true);
        if (type === 'email') {
            authForgotPassword(setDefaultEnvObj(user), user, { email: email })
                .then((response) => {
                    if (response?.status === true) {
                        setSendResetLink(true);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    Notification.send({
                        duration: 5,
                        type: 'error',
                        message: error.response?.data?.message || translation['somethingWentWrong'],
                    });
                });
        } else {
            authForgotPassword(setDefaultEnvObj(user), user, {
                phone: countryCode + mobileNumber,
            })
                .then((response) => {
                    if (response?.status === true) {
                        setSendResetLink(true);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    Notification.send({
                        duration: 5,
                        type: 'error',
                        message: error.response?.data?.message || translation['somethingWentWrong'],
                    });
                });
        }
    };
    return (
        <div className={cx('forgotPasswordOTPWidget-view')}>
            {isLoading && <ThreeBounceAnimationIcon />}
            {!sendResetLink ? (
                <Fragment>
                    <div
                        className={cx(`forgot-password-close-icon`)}
                        onClick={() => {
                            if (onForgotPasswordClose)
                                onForgotPasswordClose(false);
                        }}
                    >
                        <CrossRegularSmdBlackIcon />
                    </div>

                    <div className={cx(`wrapper`)}>
                        <TapIcon />
                        {type === 'email' ? (
                            <h1>{translation[`emailMessage`]}</h1>
                        ) : (
                            <h1>{translation[`mobileMessage`]}</h1>
                        )}
                    </div>

                    <div className={cx(`element-wrap`)}>
                        {type === 'email' ? (
                            <input
                                className={`email-wrap`}
                                type="text"
                                placeholder={
                                    translation[`emailInputPlaceholder`]
                                }
                                value={email}
                                readOnly
                            />
                        ) : (
                            <div className={`mobile-wrap`}>
                                <span
                                    className={cx(
                                        `flag-icons-sprite flag-${isoCode}`
                                    )}
                                ></span>
                                <span className={cx(`country-code`)}>
                                    {countryCode}
                                </span>
                                <input
                                    type={`tel`}
                                    value={mobileNumber}
                                    readOnly
                                />
                            </div>
                        )}
                        <button
                            className={cx(`send-btn`)}
                            onClick={() => onForgotPasswordBtnClick()}
                        >
                            {translation[`send`]}
                        </button>
                    </div>
                </Fragment>
            ) : (
                <ResetLinkSuccessWidget
                    email={email}
                    mobileNumber={mobileNumber}
                    countryCode={countryCode}
                    type={type}
                    translation={translation}
                    onSendResetLink={onSendResetLink}
                    onForgotPasswordClose={onForgotPasswordClose}
                />
            )}
        </div>
    );
};

export default ForgotPasswordOTPWidget;
